export const getForgotPassword = (state) => state.auth.forgotPassword;
export const getLoading = (state) => state.auth.forgotPassword.loading;
